<template>
  <div class="availability-online-booking-switch">
    <sp-switch
      :checked="checked"
      :label="label"
      :data-testid="TestId.finder.availabilityOnlineBooking"
      @update-checked="handleUpdateChecked"
    ></sp-switch>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { firstDetail } from "#ce/utils/events";
import { TestId } from "#/test-ids";
import { t } from "#ce/shared/filters/availability/i18n";

const emit = defineEmits(["update-checked"]);

defineProps({
  /** Whether filtering by online booking is on. */
  checked: {
    type: Boolean,
    default: false,
  },
});

const label = computed(() => t("online_booking_only"));

function handleUpdateChecked(event) {
  emit("update-checked", Boolean(firstDetail(event)));
}
</script>

<style lang="scss" scoped>
.availability-online-booking-switch {
  display: block;
  width: 100%;
}
</style>
